module.exports = __webpack_public_path__ + "static/media/realtime_tracking.d31861d6.png";